import { combineReducers } from 'redux';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { sessionReducer } from 'modules/session-management/redux';
import { userReducer } from 'modules/user-management/redux';
import { dataEditorReducer } from 'modules/data-editor/redux';
import { masterDataReducer } from 'modules/master-data/redux';
import { AppDispatch } from './store.config';
import { previewDataReducer } from '../preview-data';
import { appStateReducer } from '../app-state';
import { fileUploadReducer } from '../file-upload';
import { downloadTemplateReducer } from '../download-template';
import { configurationReducer } from 'modules/configuration/redux';
import { archiveReducer } from 'modules/archive/redux';
import { userReducer as appUserReducer } from '../user';
import { entityReducer } from '../entity';
import { syncHistoryReducer } from 'modules/sync-history/redux';
import { datamanagementReducer } from 'modules/data-management/redux';

const rootReducer = combineReducers({
    session: sessionReducer,
    user: userReducer,
    dataEditor: dataEditorReducer,
    downloadTemplate: downloadTemplateReducer,
    masterData: masterDataReducer,
    configurationData: configurationReducer,
    previewData: previewDataReducer,
    appState: appStateReducer,
    fileUpload: fileUploadReducer,
    archive: archiveReducer,
    appUser: appUserReducer,
    entity: entityReducer,
    syncHistory: syncHistoryReducer,
    dataManagement: datamanagementReducer
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
